import { formatCurrency } from './formatters';

export const generateContent = async (data) => {
  // Simulamos latencia de la IA
  await new Promise(resolve => setTimeout(resolve, 2000));

  const {
    propertyType, operation, address, city, state, price, currency,
    bedrooms, bathrooms, area, areaUnit, parking, amenities
  } = data;

  const formattedPrice = formatCurrency(price, currency);
  const isRent = operation === 'Renta';
  
  const hasBedrooms = ['Casa', 'Departamento'].includes(propertyType);
  const hasBathroomsAndParking = propertyType !== 'Terreno';
  const parkingCount = Number(parking) || 0;

  // 1. Descripción Profesional para Portales y PDF
  let description = `¡Oportunidad Exclusiva en ${city}, ${state}!\n\n`;
  
  description += `Se ofrece en ${operation.toLowerCase()} esta espectacular propiedad tipo ${propertyType.toLowerCase()}, ubicada en ${address || 'una de las zonas con mayor demanda'}. `;
  description += `Con una extensión de ${area} ${areaUnit}, esta propiedad ha sido diseñada para maximizar el confort y la funcionalidad. `;

  let features = [];
  if (hasBedrooms && bedrooms) features.push(`${bedrooms} habitaciones espaciosas`);
  if (hasBathroomsAndParking && bathrooms) features.push(`${bathrooms} baños completos`);
  
  // Lógica de Parqueos: Solo agregar si es mayor a 0
  if (hasBathroomsAndParking && parkingCount > 0) {
    features.push(`estacionamiento privado para ${parkingCount} vehículo${parkingCount > 1 ? 's' : ''}`);
  }

  if (features.length > 0) {
    if (features.length === 1) {
      description += `La propiedad cuenta con ${features[0]}. `;
    } else {
      const lastFeature = features.pop();
      description += `La propiedad cuenta con ${features.join(', ')} y ${lastFeature}. `;
    }
  }

  if (amenities) {
    description += `\n\nDetalles adicionales: ${amenities}. `;
  }

  description += `\n\nPrecio de inversión: ${formattedPrice} ${isRent ? 'mensuales' : ''}. `;
  description += `Para más información o agendar una visita, contacta a Arboleda Bienes Raíces. ¡Tu próximo paso comienza aquí!`;

  // 2. Instagram Copy (Mantiene Emojis)
  let instagram = `✨ ¡Descubre tu próximo destino en ${city}! 🇭🇳🏡\n\n`;
  instagram += `📌 Tipo: ${propertyType}\n`;
  instagram += `🔑 Trato: En ${operation}\n\n`;
  
  if (hasBedrooms && bedrooms) {
    instagram += `🛏️ ${bedrooms} Habitaciones\n`;
  }
  if (hasBathroomsAndParking && bathrooms) {
    instagram += `🛁 ${bathrooms} Baños\n`;
  }
  
  // En Instagram, si es 0, simplemente no ponemos la línea de parqueo para mantener el copy limpio
  if (hasBathroomsAndParking && parkingCount > 0) {
    instagram += `🚗 ${parkingCount} Parqueo${parkingCount > 1 ? 's' : ''}\n`;
  }
  
  instagram += `📏 ${area} ${areaUnit}\n`;
  instagram += `📍 ${state}, Honduras\n\n`;
  
  instagram += `💰 Precio: ${formattedPrice} ${isRent ? '/ mes' : ''}\n\n`;
  instagram += `📲 ¡Contáctanos vía DM o WhatsApp para detalles exclusivos!\n\n`;
  
  const hashtags = [
    '#ArboledaHN', '#BienesRaicesHonduras', '#HondurasRealEstate',
    `#${city.replace(/\s+/g, '')}`, '#InversionesHonduras', '#RealEstateHN'
  ];
  instagram += hashtags.join(' ');

  return { description, instagram };
};